import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
import { Container, Row, Col, FormGroup, Label, Input, Card, CardBody, InputGroup, InputGroupText, FormText } from "reactstrap";
import { Loading } from "../share/loading";
import { FaSistrix } from "react-icons/fa";
import { Formik, Field, Form } from "formik";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as Yup from "yup";
import "../share/form.css";
import Swal from "sweetalert2";
import { NumericFormat } from 'react-number-format';
import { CustomInputNumeric } from "../share/CustomInputNumeric";
import { DatePickerInput } from "../share/DatePickerInput";
import { FormikSelect } from "../share/FormikSelect";

export function CreateBorrowFormComponent() {

    const user = JSON.parse(localStorage.getItem("userData"));
    const [searchParams] = useSearchParams();
    let borrowId = searchParams.get("req");
    const [data, setData] = useState({});
    // console.log("data", data);
    const formikRef = useRef(null); // ✅ ใช้ useRef เพื่อดึง setFieldValue ภายนอก

    const [listregisterOptions, setListRegisterOptions] = useState([]);
    // console.log("listregisterOptions", listregisterOptions);
    const [selectRegisterId, setSelectRegisterId] = useState(0);
    const [trainTypeData, setTrainTypeData] = useState({});
    const [testTypeData, setTestTypeData] = useState({});
    // const [dataRegister, setDataRegister] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [userProfile, setUserProfile] = useState(null);
    // console.log("userProfile", userProfile); 
    const [userAuthRegister, setUserAuthRegister] = useState([]);

    let mergeInitital = {
        ...data,
        ...trainTypeData,
        ...testTypeData,
    };
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // state ดึงข้อมูลจาก master data
    const [deptsData, setDeptsData] = useState([]);
    const [titleName, setTitleName] = useState([]);
    const [titleNameGuarantee, setTitleNameGuarantee] = useState([]);



    useEffect(() => {
        GetVMdDept();
        GetTitleName();
    }, []);

    const getProfile = async () => {
        try {
            let formData = new FormData();
            formData.append("registerId", selectRegisterId ?? 0)
            const res = await fetch("/api/Profile/getProfile", {
                method: "POST",
                headers: { 'token': user.token },
                body: formData
            })
            const resJson = await res.json();

            resJson.dataenum.authorizedList = resJson.dataenum.authRegister;
            setUserProfile(resJson.dataenum);
            setUserAuthRegister(resJson.dataenum.authRegister);
            if (borrowId == "0") {
                // ✅ ใช้ setFieldValue ผ่าน formikRef
                formikRef.current?.setFieldValue("deptId", resJson.dataenum.deptId);
            }

        } catch (e) {
            // console.log("err", e)
        }
    };
    useEffect(() => {
        getProfile();
    }, [selectRegisterId])

    async function GetVMdDept() {
        setLoading(true);
        try {
            const responseDept = await fetch("/api/MasterData/getVMdDept");
            const resJson = await responseDept.json();
            setDeptsData(resJson.dataenum.map((item) => ({
                value: item.deptId,
                label: item.site
            })))
        } catch (e) {
            // console.log("err => " + e);
        } finally {
            setLoading(false);
        }
    }


    async function GetTitleName() {
        const res = await fetch("/api/MasterData/getTitle");
        const data = await res.json();
        setTitleName(data.dataenum);
        setTitleNameGuarantee(data.dataenum);
    }

    // ดึงข้อมูลการฝึกอบรม ว่ามีมั้ย  
    useEffect(() => {
        async function GetPaymentTypeTrain() {
            setLoading(true);
            let postData = new FormData();
            postData.append("borrowId", searchParams.get("req"));
            try {
                let res = await fetch("/api/OfficerBorrowing/getPaymentTypeTrain", {
                    method: "POST",
                    body: postData,
                });
                let resJson = await res.json();
                // console.log(resJson.dataenum);
                if (resJson.dataenum.length) {
                    resJson.dataenum.map((item) => {
                        item["train"] = true;
                        item = JSON.stringify(item).replace(/null/g, `""`);
                        setTrainTypeData(JSON.parse(item));
                    });
                } else {
                    setTrainTypeData({
                        train: false,
                        trainAmountLimit: "",
                        trainCourse: "",
                        trainClass: "",
                        trainPersonTotal: "",
                    })
                }
            } catch (e) {
            } finally {
                setLoading(false);
            }
        }
        GetPaymentTypeTrain();
    }, []);

    //ดึงข้อมูลการดำเนินการทดสอบ ว่ามีมั้ย
    useEffect(() => {
        async function GetPaymentTypeTest() {
            setLoading(true);
            if (searchParams.get("req") !== "0") {
                let postData = new FormData();
                postData.append("borrowId", searchParams.get("req"));
                try {
                    let res = await fetch("/api/OfficerBorrowing/getPaymentTypeTest", {
                        method: "POST",
                        body: postData,
                    });
                    let resJson = await res.json();
                    // console.log(resJson.dataenum);
                    if (resJson.dataenum.length) {
                        resJson.dataenum.map((item) => {
                            item["test"] = true;
                            item = JSON.stringify(item).replace(/null/g, `""`);
                            setTestTypeData(JSON.parse(item));
                        });
                    } else {
                        setTestTypeData({
                            test: false,
                            testAmountLimit: "",
                            testCourse: "",
                            testClass: "",
                            testPersonTotal: "",
                        });
                    }
                } catch (e) {
                    // console.log(e);
                } finally {
                    setLoading(false);
                }
            } else {
                return;
            }

        }
        GetPaymentTypeTest();
    }, []);


    useEffect(() => {
        async function getTdBorrow() {

            if (searchParams.get("req") !== "0") {
                setLoading(true);
                let postData = new FormData();
                postData.append("borrowId", searchParams.get("req"));
                try {
                    let res = await fetch("/api/OfficerBorrowing/getBorrowById", {
                        method: "POST",
                        body: postData,
                    });
                    let resJson = await res.json();
                    // console.log("223 =>",resJson.dataenum);
                    await resJson.dataenum.map((item) => {
                        item["registerId"] = Number(item.registerId);
                        setSelectRegisterId(Number(item.registerId));
                        item["status"] = searchParams.get("status")
                        item["borrowId"] = searchParams.get("req")
                        item["term"] = true;
                        if (item["titleIdGarantee"] !== null) {
                            item["optionGuarantee"] = "3";
                        } else if (item["fBondPathView"] !== null) {
                            item["optionGuarantee"] = "1";
                        } else if (item["fBankGuaranteePathView"] !== null) {
                            item["optionGuarantee"] = "2";
                        }
                        // console.log("230", item)
                        item = JSON.stringify(item).replace(/null/g, `""`);
                        item = JSON.parse(item);
                        // console.log("item",item);

                        setData((prev) => {
                            return { ...prev, ...item };
                        });
                    });
                } catch (e) {
                    // console.log(e);
                } finally {
                    setLoading(false);
                }
            } else {
                return;
            }


        }
        getTdBorrow();
    }, []);


    // useEffect(() => {
    //     getProfile();
    // }, [])

    useEffect(() => {
        const GetListRegister = async () => {
            try {
                const res = await fetch("/api/OfficerBorrowing/listRegister", {
                    method: "GET",
                    headers: { 'token': user.token },
                })
                const resJson = await res.json();
                setListRegisterOptions(resJson.dataenum);
            } catch (e) {
                // console.log("err", e)
            }
        }
        GetListRegister();
    }, [])



    const formInitialValues = {
        borrowId: searchParams.get("req"),
        status: searchParams.get("status"),
        customerTypeAr: "",
        registerId: 0,
        deptId: "", //หน่วยงานที่จะยื่น
        employeeAmount: "", //จำนวนลูกจ้าง
        authRegisterId: 0,
        // titleId: "", //คำนำหน้าชื่อ
        // fullName: "", // ชื่อผู้กระทำการแทน
        // personalNo: "", //เลขบัตรประชาชน
        position: "", //ตำแหน่งงาน
        age: "", //อายุ
        national: "", //สัญชาติ
        cardExpireDate: "", //วันที่บัตรหมดอายุ
        birthDate: "", // วันเกิด
        optionGuarantee: "",

        //ฝึกอบรม
        train: false,
        trainAmountLimit: "",
        trainCourse: "",
        trainClass: "",
        trainPersonTotal: "",

        //ดำเนินการทดสอบ
        test: false,
        testAmountLimit: "",
        testCourse: "",
        testClass: "",
        testPersonTotal: "",

        //หลักประกันในการกู้
        fBondPath: "",
        fBankGuaranteePath: "",
        titleIdGarantee: "",
        nameGuarantee: "",
        nameGuaranteePosition: "",
        term: false,

        fAuthorizePath: "",
        fIdCardPath: "",
        fAuthoriseIdCardPath: "",
        fBureauPath: "",
        fStatementPath: "",
        fLocationPath: "",
        fSubsidyPath: "",
        fOtherPath: "",
    };

    const validateSchema = Yup.object().shape({
        customerTypeAr: Yup.string().required("กรุณาเลือกประเภทการขอกู้ยืมเงิน"),
        deptId: Yup.string().required("กรุณาเลือกหน่วยงานที่ยื่นคำขอ"),
        // titleId: Yup.string().required("กรุณาเลือกคำนำหน้าชื่อ"),
        // fullName: Yup.string().required("กรุณากรอกชื่อ-สกุล"), // ชื่อผู้กระทำการแทน
        // personalNo: Yup.string().min(13, "เลขบัตรประจำตัวประชาชน ต้องมีจำนวน 13 หลัก").required("กรุณากรอกเลขประจำตัวประชาชน"), //เลขบัตรประชาชน
        position: Yup.string().required("กรุณากรอกตำแหน่งงาน"), //ตำแหน่งงาน
        age: Yup.string()
            .matches(/^[0-9]{2}$/, "อายุต้องเป็นตัวเลขเท่านั้น")
            .required("กรุณากรอกอายุ"), //อายุ

        national: Yup.string().required("กรุณากรอกสัญชาติ"), //สัญชาติ

        cardExpireDate: Yup.date().required("กรุณาเลือก")
            .min(new Date(), "วันที่บัตรหมดอายุต้องไม่น้อยกว่าวันที่ปัจจุบัน"),
        // .required("กรุณากรอกวันที่บัตรหมดอายุ"), //วันที่บัตรหมดอายุ

        birthDate: Yup.date().required("กรุณาเลือก")
            .max(new Date(), "วันเกิดต้องไม่น้อยกว่าวันที่ปัจจุบัน"),
        // .required("กรุณากรอกวันเกิด"),
        // วันเกิด

        licenseNo: Yup.string(), //เลขที่ใบอนุญาตการเป็นผู้ดำเนินการทดสอบ

        employeeAmount: Yup.number()
            .typeError("จำนวนลูกจ้างต้องเป็นตัวเลขเท่านั้น"),
        // .required("กรุณากรอกจำนวนลูกจ้างที่นำส่งเงินสมทบประกันสังคม"), //จำนวนลูกจ้าง

        train: Yup.boolean(),
        test: Yup.boolean(),

        // ดำเนินการฝึก
        trainAmountLimit: Yup.string().when("train", {
            is: true,
            then: Yup.string().required("กรุณากรอกวงเงินที่ขอกู้"),
        }),
        trainCourse: Yup.string().when("train", {
            is: true,
            then: Yup.string().required("กรุณากรอกจำนวนหลักสูตร"),
        }),
        trainClass: Yup.string().when("train", {
            is: true,
            then: Yup.string().required("กรุณากรอกจำนวนรุ่น"),
        }),
        trainPersonTotal: Yup.string().when("train", {
            is: true,
            then: Yup.string().required("กรุณากรอกจำนวนผู้เข้ารับการฝึกอบรม"),
        }),

        // ดำเนินการทดสอบ
        testAmountLimit: Yup.string().when("test", {
            is: true,
            then: Yup.string().required("กรุณากรอกวงเงินที่ขอกู้"),
        }),
        testCourse: Yup.string().when("test", {
            is: true,
            then: Yup.string().required("กรุณากรอกจำนวนสาขาอาชีพ"),
        }),
        testClass: Yup.string().when("test", {
            is: true,
            then: Yup.string().required("กรุณากรอกจำนวนสาขา"),
        }),
        testPersonTotal: Yup.string().when("test", {
            is: true,
            then: Yup.string().required(
                "กรุณากรอกจำนวนผู้เข้ารับการทดสอบมาตรฐานฝีมือแรงงาน"
            ),
        }),
        optionGuarantee: Yup.string().required("กรุณาเลือกหลักประกันในการกู้"),

        fBondPath: Yup.mixed().when("optionGuarantee", {
            is: "1",
            then: Yup.mixed().required("กรุณาแนบไฟล์พันธบัตรรัฐบาลไทย"),
        }),
        fBankGuaranteePath: Yup.mixed().when("optionGuarantee", {
            is: "2",
            then: Yup.mixed().required("กรุณาแนบไฟล์หนังสือค้ำประกันธนาคาร"),
        }),
        titleIdGarantee: Yup.string().when("optionGuarantee", {
            is: "3",
            then: Yup.string().required("กรุณาเลือกคำนำหน้าชื่อ"),
        }),
        nameGuarantee: Yup.string().when("optionGuarantee", {
            is: "3",
            then: Yup.string().required("กรุณากรอกชื่อผู้ค้ำประกัน"),
        }),
        nameGuaranteePosition: Yup.string().when("optionGuarantee", {
            is: "3",
            then: Yup.string().required("กรุณากรอกตำแหน่งงานผู้ค้ำประกัน"),
        }),

        fBureauPath: Yup.mixed().when("borrowId", {
            is: "0",
            then: Yup.mixed().required("กรุณาแนบไฟล์").test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf หรือ excel ', (value) => {
                return value && ['application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(value.type)
            }).test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', (value) => {
                const maxSize = 5000000;
                return !value || (value.size <= maxSize);
            }),
        }),
        fStatementPath: Yup.mixed().when("borrowId", {
            is: "0",
            then: Yup.mixed().required("กรุณาแนบไฟล์").test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf หรือ excel ', (value) => {
                return value && ['application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(value.type)
            }).test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', (value) => {
                const maxSize = 5000000;
                return !value || (value.size <= maxSize);
            })
        }),
        fLocationPath: Yup.mixed().when("borrowId", {
            is: "0",
            then: Yup.mixed().required("กรุณาแนบไฟล์").test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg ', (value) => {
                return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type)
            }).test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 2MB', (value) => {
                const maxSize = 5000000;
                return !value || (value.size <= maxSize);
            })
        }),
        fSubsidyPath: Yup.mixed().when("borrowId", {
            is: "0",
            then: Yup.mixed()
                .required("กรุณาแนบไฟล์")
                .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', (value) => {
                    return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type)
                })
                .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', (value) => {
                    const maxSize = 5000000;
                    return !value || (value.size <= maxSize);
                }),
        }),
        term: Yup.bool().oneOf([true], "กรุณายอมรับข้อตกลง"),
    });

    const onSubmit = async (values) => {
        // console.log(values);
        Swal.fire({
            icon: "info",
            title: "ยืนยันการบันทึกข้อมูลหรือไม่?",
            allowOutsideClick: false,
            allowEscapeKey: false,
            text: "",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ยันยัน",
            cancelButtonText: 'ยกเลิก',
            cancelButtonColor: '#d33',
            showCancelButton: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                let postData = new FormData();
                Object.entries(values).forEach(([key, value]) => {
                    postData.append(key, value);
                });

                try {
                    let res = await fetch("/api/OfficerBorrowing/saveBorrowForm", {
                        method: "POST",
                        body: postData,
                    });

                    let resJson = await res.json();
                    // console.log(resJson.dataenum);
                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "บันทึกข้อมูลสำเร็จ",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            text: "บันทึกข้อมูลต่อหรือไม่ ?",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                values.train === true ? navigate(`/borrowing/create-train-borrowing?req=${resJson.dataenum}&train=${values.train}&test=${values.test}&status=${values.status}`)
                                    : navigate(`/borrowing/create-testing-borrowing?req=${resJson.dataenum}&train=${values.train}&test=${values.test}&status=${values.status}`);
                            }
                        });
                    } else if (resJson.status === 3) {
                        Swal.fire({
                            icon: "success",
                            title: "อัพเดทข้อมูลสำเร็จ",
                            text: "บันทึกข้อมูลต่อหรือไม่?",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                values.train === true ? navigate(`/borrowing/create-train-borrowing?req=${values.borrowId}&train=${values.train}&test=${values.test}&status=${values.status}`)
                                    : navigate(`/borrowing/create-testing-borrowing?req=${values.borrowId}&train=${values.train}&test=${values.test}&status=${values.status}`);
                            }
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                    }
                } catch (e) {
                    // console.log(e);
                }
            } else {
                return;
            }
        });

    };

    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    function onClickUrl(url) {
        return () => openInNewTab(url)
    }

    const authRegisterOptions = userAuthRegister?.map((item) => ({
        label: item.authFullName,
        value: item.authRegisterId
    })) || [];


    const toText = (v) => (v ?? "").toString().toLowerCase();

    const customFilter = (option, rawInput) => {
        const q = toText(rawInput);
        const d = option && option.data ? option.data : {};
        return [d.companyNo, d.customerNo, d.fullName].some((f) => toText(f).includes(q));
    };

    // สมมติ data มาจาก API
    const registerOptions = (listregisterOptions || []).map((x) => ({
        value: x.registerId, // เก็บค่า registerId
        // label: `${x.companyNo ?? "-"} | ${x.customerNo ?? "-"} | ${x.fullName ?? "-"}`,
        label: `${x.fullName ?? "-"}`,

        companyNo: x.companyNo ?? "",
        customerNo: x.customerNo ?? "",
        fullName: x.fullName ?? "",
    }));

    return (
        <Formik
            innerRef={formikRef} // ✅ ตรงนี้สำคัญ
            initialValues={
                searchParams.get("req") !== "0" ? mergeInitital : formInitialValues
            }
            validationSchema={validateSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {({ values, errors, touched, setFieldValue, handleBlur, handleChange, handleSubmit }) => {

                // console.log("values", values);
                // console.log("errors", errors)

                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {loading && loadingData ? (
                            <Loading />
                        ) : (

                            <div className="form-border" style={{ maxWidth: "1300px", width: "100%" }}>
                                <Form
                                    autoComplete="off"
                                    onSubmit={handleSubmit}
                                    className="mb-4"
                                >
                                    <div className="p-5">
                                        <Field
                                            name={`borrowId`}
                                            type="text"
                                            disabled={true}
                                            style={{ display: "none" }}
                                        />
                                        <Field
                                            name={`status`}
                                            type="text"
                                            disabled={true}
                                            style={{ display: "none" }}
                                        />

                                        <FormGroup className="mb-3">
                                            <Label htmlFor="establishmentId" className="fw-semibold">
                                                เลือกสถานประกอบการที่จะลงทะเบียนให้ <span className="require-input">*</span>
                                            </Label>

                                            <Select
                                                options={registerOptions}
                                                filterOption={customFilter}
                                                placeholder="ค้นหาโดย เลขทะเบียนนิติบุคคล 13 หลัก, เลขสถานประกอบการ 10 หลัก หรือ ชื่อสถานประกอบการ"
                                                isClearable
                                                noOptionsMessage={() => "ไม่พบข้อมูล"}
                                                onChange={(selected) => {
                                                    // selected = { value, label, companyNo, customerNo, fullName }
                                                    setSelectRegisterId(selected.value)
                                                    setFieldValue("registerId", selected ? selected.value : "");
                                                }}
                                                value={registerOptions.find(item => item.value == selectRegisterId)}
                                            />
                                        </FormGroup>
                                        {/* ปุ่มลงทะเบียนใหม่ */}
                                        {/* <div className="d-flex align-items-center mt-2">
                                            <span className="me-3 text-muted">
                                                หากยังไม่ได้ลงทะเบียนสถานประกอบการในระบบ
                                            </span>
                                            <button
                                                type="button"
                                                className="btn btn-outline-primary rounded-pill px-4"
                                                onClick={() => navigate("/registeration/registerType/company")} // 🔧 route ปรับตามจริง
                                            >
                                                ลงทะเบียน
                                            </button>
                                        </div> */}
                                        {/* ดึงข้อมูลมาแสดง */}

                                        {/* <Label className="mb-3 input-color">กรุณากรอกรายละเอียดการขอกู้ยืมเงิน</Label>
                                        <br /> */}
                                        <br />
                                        {/* input แบบฟอร์ม */}
                                        <Label className="me-4" for="selectTypeBorrow">
                                            เลือกประเภทการขอเงินกู้ยืมเงิน
                                            {/* <span className="require-input">*</span> */}
                                        </Label>
                                        {errors.customerTypeAr ? (
                                            <span className="text-left text-danger mx-1">
                                                {errors.customerTypeAr}
                                            </span>
                                        ) : null}

                                        {/* input เลือกประเภทการสมัคร */}
                                        <div className="m-0 p-3">
                                            <FormGroup>
                                                <Field name="customerTypeAr" type="radio" value="1">
                                                    {({ field }) => (
                                                        <Input
                                                            type="radio"
                                                            className="mx-2 cus-type"
                                                            {...field}
                                                        />
                                                    )}
                                                </Field>

                                                <Label>ผู้ประกอบกิจการ</Label>
                                            </FormGroup>
                                            <FormGroup>
                                                <Field name="customerTypeAr" type="radio" value="2">
                                                    {({ field }) => (
                                                        <Input
                                                            type="radio"
                                                            className="mx-2 cus-type"
                                                            {...field}
                                                        />
                                                    )}
                                                </Field>
                                                <Label>ผู้ดำเนินการฝึก</Label>
                                            </FormGroup>
                                            <FormGroup>
                                                <Field name="customerTypeAr" type="radio" value="3">
                                                    {({ field }) => (
                                                        <Input
                                                            type="radio"
                                                            className="mx-2 cus-type"
                                                            {...field}
                                                        />
                                                    )}
                                                </Field>
                                                <Label>ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน</Label>
                                            </FormGroup>
                                        </div>

                                        {/* ฟอร์มหลัก: สวย & Responsive */}
                                        <Row className="gy-4 gx-3">

                                            {/* ยื่นคำขอที่ / โดย */}
                                            <Col xs="12" md="6">
                                                <FormGroup className="mb-0">
                                                    <Label htmlFor="deptId" className="fw-semibold">
                                                        ยื่นคำขอที่ <span className="require-input">*</span>
                                                    </Label>
                                                    <Field
                                                        name="deptId"
                                                        component={FormikSelect}
                                                        options={deptsData}
                                                        placeholder={<div className="input-color">กรุณาเลือกหน่วยงาน</div>}
                                                    />
                                                    {touched.deptId && errors.deptId && (
                                                        <div className="invalid-feedback d-block">{errors.deptId}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col xs="12" md="6">
                                                <FormGroup className="mb-0">
                                                    <Label htmlFor="authRegisterId" className="fw-semibold">
                                                        โดย (ผู้มีอำนาจกระทำการแทน/ผู้รับมอบอำนาจ) <span className="require-input">*</span>
                                                    </Label>
                                                    <Field
                                                        name="authRegisterId"
                                                        component={FormikSelect}
                                                        options={authRegisterOptions}
                                                        placeholder={<div className="input-color">กรุณาเลือกผู้มีอำนาจ</div>}
                                                    />
                                                    {touched.authRegisterId && errors.authRegisterId && (
                                                        <div className="invalid-feedback d-block">{errors.authRegisterId}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            {/* ตำแหน่ง / อายุ / สัญชาติ */}
                                            <Col xs="12" lg="6">
                                                <FormGroup className="mb-0">
                                                    <Label htmlFor="position" className="fw-semibold">
                                                        ตำแหน่ง <span className="require-input">*</span>
                                                    </Label>
                                                    <Input
                                                        id="position"
                                                        name="position"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.position}
                                                        className={`rounded-pill input-color ${touched.position && errors.position ? "input-error" : ""}`}
                                                    />
                                                    {touched.position && errors.position && (
                                                        <div className="invalid-feedback d-block">{errors.position}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col xs="12" sm="6" lg="3">
                                                <FormGroup className="mb-0">
                                                    <Label htmlFor="age" className="fw-semibold">
                                                        อายุ <span className="require-input">*</span>
                                                    </Label>
                                                    <InputGroup>
                                                        <Input
                                                            id="age"
                                                            name="age"
                                                            type="text"
                                                            maxLength={2}
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            value={values.age}
                                                            className={`rounded-start-pill input-color ${touched.age && errors.age ? "input-error" : ""}`}
                                                            style={{ borderTopLeftRadius: "50rem", borderBottomLeftRadius: "50rem" }} // บังคับโค้งมนด้านซ้าย
                                                        />
                                                        <InputGroupText className="rounded-end-pill">ปี</InputGroupText>
                                                    </InputGroup>
                                                    {touched.age && errors.age && (
                                                        <div className="invalid-feedback d-block">{errors.age}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col xs="12" sm="6" lg="3">
                                                <FormGroup className="mb-0">
                                                    <Label htmlFor="national" className="fw-semibold">
                                                        สัญชาติ <span className="require-input">*</span>
                                                    </Label>
                                                    <Input
                                                        id="national"
                                                        name="national"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.national}
                                                        className={`rounded-pill input-color ${touched.national && errors.national ? "input-error" : ""}`}
                                                    />
                                                    {touched.national && errors.national && (
                                                        <div className="invalid-feedback d-block">{errors.national}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            {/* วันหมดอายุบัตร / วันเกิด */}
                                            <Col xs="12" md="6">
                                                <FormGroup className="mb-0">
                                                    <Label htmlFor="cardExpireDate" className="fw-semibold">
                                                        วัน/เดือน/ปี พ.ศ. ที่บัตรหมดอายุ <span className="require-input">*</span>
                                                    </Label>
                                                    <Field
                                                        name="cardExpireDate"
                                                        component={(props) => <DatePickerInput {...props} minDate={new Date()} />}
                                                    />
                                                    {touched.cardExpireDate && errors.cardExpireDate && (
                                                        <div className="invalid-feedback d-block">{errors.cardExpireDate}</div>
                                                    )}
                                                    {/* <FormText className="text-muted">โปรดเลือกวันที่ในอนาคต</FormText> */}
                                                </FormGroup>
                                            </Col>

                                            <Col xs="12" md="6">
                                                <FormGroup className="mb-0">
                                                    <Label htmlFor="birthDate" className="fw-semibold">
                                                        วัน/เดือน/ปีเกิด <span className="require-input">*</span>
                                                    </Label>
                                                    <Field name="birthDate" component={DatePickerInput} maxDate={new Date()} />
                                                    {touched.birthDate && errors.birthDate && (
                                                        <div className="invalid-feedback d-block">{errors.birthDate}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            {/* จำนวนลูกจ้าง */}
                                            <Col xs="12" md="6">
                                                <FormGroup className="mb-0">
                                                    <Label htmlFor="employeeAmount" className="fw-semibold">
                                                        จำนวนลูกจ้างที่นำส่งเงินสมทบประกันสังคม (ณ เดือนที่ยื่นคำขอกู้)
                                                    </Label>
                                                    <InputGroup>
                                                        <Input
                                                            id="employeeAmount"
                                                            name="employeeAmount"
                                                            type="text"
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            value={values.employeeAmount}
                                                            className={`rounded-start-pill input-color ${touched.employeeAmount && errors.employeeAmount ? "input-error" : ""}`}
                                                            style={{ borderTopLeftRadius: "50rem", borderBottomLeftRadius: "50rem" }}
                                                        />
                                                        <InputGroupText className="rounded-end-pill">คน</InputGroupText>
                                                    </InputGroup>
                                                    {touched.employeeAmount && errors.employeeAmount && (
                                                        <div className="invalid-feedback d-block">{errors.employeeAmount}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                        </Row>

                                        {/* เลือกประเภทการขอกู้ยืมเงิน อบรม หรือทดสอบ  */}
                                        {/* เลือกประเภทการขอกู้ยืมเงิน อบรม หรือทดสอบ */}
                                        <FormGroup className="mt-5">
                                            <Label className="fw-bold">
                                                ข้าพเจ้ามีความประสงค์จะขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อเป็นค่าใช้จ่าย ดังนี้
                                                <span className="require-input">*</span>
                                            </Label>
                                            {errors.borrowOption && (
                                                <div className="text-danger small mt-1">{errors.borrowOption}</div>
                                            )}

                                            <Row className="g-3 mt-2">
                                                {/* การ์ด: ฝึกอบรม */}
                                                <Col xs="12" md="6">
                                                    <Card className={`${values.train ? "border-primary" : ""} h-100`}>
                                                        <CardBody>
                                                            <div className="d-flex align-items-start">
                                                                <Input
                                                                    type="checkbox"
                                                                    name="train"
                                                                    id="train"
                                                                    checked={values.train}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    className="me-2 mt-1"
                                                                    aria-label="เลือกขอกู้สำหรับการฝึกอบรม"
                                                                />
                                                                <div className="w-100">
                                                                    <Label className="m-0 fw-semibold">
                                                                        ดำเนินการฝึกอบรมฝีมือแรงงานตาม พ.ร.บ. ส่งเสริมฯ พ.ศ. 2545
                                                                    </Label>

                                                                    {/* วงเงินที่ขอกู้ */}
                                                                    <div className="mt-3">
                                                                        <Label className="form-label small mb-1" htmlFor="trainAmountLimit">
                                                                            วงเงินที่ขอกู้ (บาท)
                                                                        </Label>
                                                                        <Field name="trainAmountLimit">
                                                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                                                <NumericFormat
                                                                                    {...field}
                                                                                    allowLeadingZeros
                                                                                    thousandSeparator=","
                                                                                    decimalScale={2}
                                                                                    isNumericString
                                                                                    displayType="number"
                                                                                    value={values.trainAmountLimit}
                                                                                    format={(v) => v.toLocaleString()}
                                                                                    onValueChange={(v) => setFieldValue(field.name, v.value)}
                                                                                    customInput={CustomInputNumeric}
                                                                                    disabled={!values.train}
                                                                                    className={`rounded-pill text-center input-color ${meta.touched && meta.error ? "input-error" : ""
                                                                                        }`}
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                        {touched.trainAmountLimit && errors.trainAmountLimit && (
                                                                            <div className="invalid-feedback d-block">
                                                                                {errors.trainAmountLimit}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {/* จำนวนหลักสูตร/รุ่น */}
                                                                    <Row className="g-2 mt-2">
                                                                        <Col xs="12" sm="6">
                                                                            <Label className="form-label small mb-1" htmlFor="trainCourse">
                                                                                จำนวนหลักสูตร
                                                                            </Label>
                                                                            <Input
                                                                                id="trainCourse"
                                                                                name="trainCourse"
                                                                                type="text"
                                                                                disabled={!values.train}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                value={values.trainCourse}
                                                                                className={`rounded-pill text-center input-color ${touched.trainCourse && errors.trainCourse ? "input-error" : ""
                                                                                    }`}
                                                                            />
                                                                            {touched.trainCourse && errors.trainCourse && (
                                                                                <div className="invalid-feedback d-block">
                                                                                    {errors.trainCourse}
                                                                                </div>
                                                                            )}
                                                                        </Col>
                                                                        <Col xs="12" sm="6">
                                                                            <Label className="form-label small mb-1" htmlFor="trainClass">
                                                                                จำนวนรุ่น
                                                                            </Label>
                                                                            <Input
                                                                                id="trainClass"
                                                                                name="trainClass"
                                                                                type="text"
                                                                                disabled={!values.train}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                value={values.trainClass}
                                                                                className={`rounded-pill text-center input-color ${touched.trainClass && errors.trainClass ? "input-error" : ""
                                                                                    }`}
                                                                            />
                                                                            {touched.trainClass && errors.trainClass && (
                                                                                <div className="invalid-feedback d-block">
                                                                                    {errors.trainClass}
                                                                                </div>
                                                                            )}
                                                                        </Col>
                                                                    </Row>

                                                                    {/* รวมผู้รับการฝึก */}
                                                                    <div className="mt-2">
                                                                        <Label className="form-label small mb-1" htmlFor="trainPersonTotal">
                                                                            รวมผู้รับเข้าการฝึกอบรม (คน)
                                                                        </Label>
                                                                        <Input
                                                                            id="trainPersonTotal"
                                                                            name="trainPersonTotal"
                                                                            type="text"
                                                                            disabled={!values.train}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.trainPersonTotal}
                                                                            className={`rounded-pill text-center input-color ${touched.trainPersonTotal && errors.trainPersonTotal
                                                                                ? "input-error"
                                                                                : ""
                                                                                }`}
                                                                        />
                                                                        {touched.trainPersonTotal && errors.trainPersonTotal && (
                                                                            <div className="invalid-feedback d-block">
                                                                                {errors.trainPersonTotal}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardBody>
                                                    </Card>
                                                </Col>

                                                {/* การ์ด: ทดสอบมาตรฐานฝีมือ */}
                                                <Col xs="12" md="6">
                                                    <Card className={`${values.test ? "border-primary" : ""} h-100`}>
                                                        <CardBody>
                                                            <div className="d-flex align-items-start">
                                                                <Input
                                                                    type="checkbox"
                                                                    name="test"
                                                                    id="test"
                                                                    checked={values.test}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    className="me-2 mt-1"
                                                                    aria-label="เลือกขอกู้สำหรับการทดสอบมาตรฐานฝีมือ"
                                                                />
                                                                <div className="w-100">
                                                                    <Label className="m-0 fw-semibold">
                                                                        ดำเนินการทดสอบมาตรฐานฝีมือแรงงานตาม พ.ร.บ. ส่งเสริมฯ พ.ศ. 2545
                                                                    </Label>

                                                                    {/* วงเงินที่ขอกู้ */}
                                                                    <div className="mt-3">
                                                                        <Label className="form-label small mb-1" htmlFor="testAmountLimit">
                                                                            วงเงินที่ขอกู้ (บาท)
                                                                        </Label>
                                                                        <Field name="testAmountLimit">
                                                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                                                <NumericFormat
                                                                                    {...field}
                                                                                    allowLeadingZeros
                                                                                    thousandSeparator=","
                                                                                    decimalScale={2}
                                                                                    isNumericString
                                                                                    displayType="number"
                                                                                    value={values.testAmountLimit}
                                                                                    format={(v) => v.toLocaleString()}
                                                                                    onValueChange={(v) => setFieldValue(field.name, v.value)}
                                                                                    customInput={CustomInputNumeric}
                                                                                    disabled={!values.test}
                                                                                    className={`rounded-pill text-center input-color ${meta.touched && meta.error ? "input-error" : ""
                                                                                        }`}
                                                                                />
                                                                            )}
                                                                        </Field>
                                                                        {touched.testAmountLimit && errors.testAmountLimit && (
                                                                            <div className="invalid-feedback d-block">
                                                                                {errors.testAmountLimit}
                                                                            </div>
                                                                        )}
                                                                    </div>

                                                                    {/* จำนวนสาขาอาชีพ/สาขา */}
                                                                    <Row className="g-2 mt-2">
                                                                        <Col xs="12" sm="6">
                                                                            <Label className="form-label small mb-1" htmlFor="testCourse">
                                                                                จำนวนสาขาอาชีพ
                                                                            </Label>
                                                                            <Input
                                                                                id="testCourse"
                                                                                name="testCourse"
                                                                                type="text"
                                                                                disabled={!values.test}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                value={values.testCourse}
                                                                                className={`rounded-pill text-center input-color ${touched.testCourse && errors.testCourse ? "input-error" : ""
                                                                                    }`}
                                                                            />
                                                                            {touched.testCourse && errors.testCourse && (
                                                                                <div className="invalid-feedback d-block">
                                                                                    {errors.testCourse}
                                                                                </div>
                                                                            )}
                                                                        </Col>
                                                                        <Col xs="12" sm="6">
                                                                            <Label className="form-label small mb-1" htmlFor="testClass">
                                                                                จำนวนสาขา
                                                                            </Label>
                                                                            <Input
                                                                                id="testClass"
                                                                                name="testClass"
                                                                                type="text"
                                                                                disabled={!values.test}
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                value={values.testClass}
                                                                                className={`rounded-pill text-center input-color ${touched.testClass && errors.testClass ? "input-error" : ""
                                                                                    }`}
                                                                            />
                                                                            {touched.testClass && errors.testClass && (
                                                                                <div className="invalid-feedback d-block">
                                                                                    {errors.testClass}
                                                                                </div>
                                                                            )}
                                                                        </Col>
                                                                    </Row>

                                                                    {/* รวมผู้เข้ารับการทดสอบ */}
                                                                    <div className="mt-2">
                                                                        <Label className="form-label small mb-1" htmlFor="testPersonTotal">
                                                                            รวมผู้เข้ารับการทดสอบมาตรฐานฝีมือแรงงาน (คน)
                                                                        </Label>
                                                                        <Input
                                                                            id="testPersonTotal"
                                                                            name="testPersonTotal"
                                                                            type="text"
                                                                            disabled={!values.test}
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.testPersonTotal}
                                                                            className={`rounded-pill text-center input-color ${touched.testPersonTotal && errors.testPersonTotal
                                                                                ? "input-error"
                                                                                : ""
                                                                                }`}
                                                                        />
                                                                        {touched.testPersonTotal && errors.testPersonTotal && (
                                                                            <div className="invalid-feedback d-block">
                                                                                {errors.testPersonTotal}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </FormGroup>

                                        {/* หลักประกันในการกู้ยืม */}
                                        <FormGroup className="m-0">
                                            <Label className="fw-bold">
                                                หลักประกันในการกู้ <span className="require-input">*</span>
                                            </Label>
                                            {errors.optionGuarantee && (
                                                <div className="text-danger small mt-1">{errors.optionGuarantee}</div>
                                            )}

                                            <div className="mt-3">

                                                {/* แถวบน: พันธบัตร / Bank Guarantee */}
                                                <Row className="g-3">
                                                    {/* พันธบัตรรัฐบาลไทย */}
                                                    <Col xs="12" md="6">
                                                        <Card className={`h-100 ${values.optionGuarantee === '1' ? 'border-primary' : ''}`}>
                                                            <CardBody>
                                                                <div className="d-flex align-items-start">
                                                                    <Input
                                                                        type="radio"
                                                                        name="optionGuarantee"
                                                                        value="1"
                                                                        checked={values.optionGuarantee === "1"}
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        className="me-2 mt-1"
                                                                        aria-label="เลือกพันธบัตรรัฐบาลไทยเป็นหลักประกัน"
                                                                    />
                                                                    <div className="w-100">
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <Label className="m-0">
                                                                                พันธบัตรรัฐบาลไทย
                                                                                {errors.fBondPath && (
                                                                                    <span className="text-danger mx-1">{errors.fBondPath}</span>
                                                                                )}
                                                                            </Label>
                                                                            {values.fBondPathView && (
                                                                                <FaSistrix
                                                                                    className="ms-2 style-icon"
                                                                                    onClick={onClickUrl(`${values.fBondPathView}`)}
                                                                                    title="ดูไฟล์"
                                                                                    role="button"
                                                                                />
                                                                            )}
                                                                        </div>

                                                                        <Input
                                                                            name="fBondPath"
                                                                            type="file"
                                                                            disabled={values.optionGuarantee !== "1"}
                                                                            onBlur={handleBlur}
                                                                            className={`rounded-pill text-center input-color mt-2 ${touched.fBondPath && errors.fBondPath ? "input-error" : ""}`}
                                                                            onChange={(e) => {
                                                                                handleChange(e);
                                                                                if (e.target?.files?.[0]) setFieldValue("fBondPath", e.target.files[0]);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>

                                                    {/* หนังสือค้ำประกันธนาคาร */}
                                                    <Col xs="12" md="6">
                                                        <Card className={`h-100 ${values.optionGuarantee === '2' ? 'border-primary' : ''}`}>
                                                            <CardBody>
                                                                <div className="d-flex align-items-start">
                                                                    <Input
                                                                        type="radio"
                                                                        name="optionGuarantee"
                                                                        value="2"
                                                                        checked={values.optionGuarantee === "2"}
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        className="me-2 mt-1"
                                                                        aria-label="เลือกหนังสือค้ำประกันธนาคารเป็นหลักประกัน"
                                                                    />
                                                                    <div className="w-100">
                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <Label className="m-0">
                                                                                หนังสือค้ำประกันธนาคาร
                                                                                {errors.fBankGuaranteePath && (
                                                                                    <span className="text-danger mx-1">{errors.fBankGuaranteePath}</span>
                                                                                )}
                                                                            </Label>
                                                                            {values.fBankGuaranteePathView && (
                                                                                <FaSistrix
                                                                                    className="ms-2 style-icon"
                                                                                    onClick={onClickUrl(`${values.fBankGuaranteePathView}`)}
                                                                                    title="ดูไฟล์"
                                                                                    role="button"
                                                                                />
                                                                            )}
                                                                        </div>

                                                                        <Input
                                                                            name="fBankGuaranteePath"
                                                                            type="file"
                                                                            disabled={values.optionGuarantee !== "2"}
                                                                            onBlur={handleBlur}
                                                                            className={`rounded-pill text-center input-color mt-2 ${touched.fBankGuaranteePath && errors.fBankGuaranteePath ? "input-error" : ""}`}
                                                                            onChange={(e) => {
                                                                                handleChange(e);
                                                                                if (e.target?.files?.[0]) setFieldValue("fBankGuaranteePath", e.target.files[0]);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>

                                                {/* บุคคลค้ำประกัน */}
                                                <Row className="g-3 mt-1">
                                                    <Col xs="12">
                                                        <Card className={`h-100 ${values.optionGuarantee === '3' ? 'border-primary' : ''}`}>
                                                            <CardBody>
                                                                <div className="d-flex align-items-start">
                                                                    <Input
                                                                        type="radio"
                                                                        name="optionGuarantee"
                                                                        value="3"
                                                                        checked={values.optionGuarantee === "3"}
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        className="me-2 mt-1"
                                                                        aria-label="เลือกบุคคลค้ำประกันเป็นหลักประกัน"
                                                                    />
                                                                    <div className="w-100">
                                                                        <Label className="m-0 fw-semibold">บุคคลค้ำประกัน</Label>

                                                                        {/* แถวฟอร์ม: คำนำหน้า / ชื่อ–สกุล / ตำแหน่ง */}
                                                                        <Row className="g-2 mt-2 align-items-end">
                                                                            {/* คำนำหน้า */}
                                                                            <Col xs="12" md="3">
                                                                                <Label className="form-label small mb-1">คำนำหน้า</Label>
                                                                                <Input
                                                                                    type="select"
                                                                                    name="titleIdGarantee"
                                                                                    id="titleIdGarantee"
                                                                                    disabled={values.optionGuarantee !== "3"}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={handleChange}
                                                                                    value={values.titleIdGarantee}
                                                                                    invalid={Boolean(touched.titleIdGarantee && errors.titleIdGarantee)}
                                                                                    className="rounded-pill text-center input-color"
                                                                                >
                                                                                    <option value="">เลือกคำนำหน้า</option>
                                                                                    {titleNameGuarantee.map((t) => (
                                                                                        <option key={t.titleCode} value={t.titleCode}>{t.titleThai}</option>
                                                                                    ))}
                                                                                </Input>
                                                                                {touched.titleIdGarantee && errors.titleIdGarantee && (
                                                                                    <div className="invalid-feedback d-block">{errors.titleIdGarantee}</div>
                                                                                )}
                                                                            </Col>

                                                                            {/* ชื่อ–สกุล */}
                                                                            <Col xs="12" md="6">
                                                                                <Label className="form-label small mb-1">ชื่อ–สกุล</Label>
                                                                                <Input
                                                                                    type="text"
                                                                                    name="nameGuarantee"
                                                                                    id="nameGuarantee"
                                                                                    placeholder="กรุณากรอกชื่อ–สกุล"
                                                                                    disabled={values.optionGuarantee !== "3"}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={handleChange}
                                                                                    value={values.nameGuarantee}
                                                                                    invalid={Boolean(touched.nameGuarantee && errors.nameGuarantee)}
                                                                                    className="rounded-pill text-center input-color"
                                                                                />
                                                                                {touched.nameGuarantee && errors.nameGuarantee && (
                                                                                    <div className="invalid-feedback d-block">{errors.nameGuarantee}</div>
                                                                                )}
                                                                            </Col>

                                                                            {/* ตำแหน่ง */}
                                                                            <Col xs="12" md="3">
                                                                                <Label className="form-label small mb-1">ตำแหน่ง</Label>
                                                                                <Input
                                                                                    type="text"
                                                                                    name="nameGuaranteePosition"
                                                                                    id="nameGuaranteePosition"
                                                                                    placeholder="ตำแหน่ง"
                                                                                    disabled={values.optionGuarantee !== "3"}
                                                                                    onBlur={handleBlur}
                                                                                    onChange={handleChange}
                                                                                    value={values.nameGuaranteePosition}
                                                                                    invalid={Boolean(touched.nameGuaranteePosition && errors.nameGuaranteePosition)}
                                                                                    className="rounded-pill text-center input-color"
                                                                                />
                                                                                {touched.nameGuaranteePosition && errors.nameGuaranteePosition && (
                                                                                    <div className="invalid-feedback d-block">{errors.nameGuaranteePosition}</div>
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>

                                            </div>
                                        </FormGroup>
                                        {/* แบนไฟล์ต่างๆ */}

                                        <Row className="g-3">
                                            {/* หนังสือมอบอำนาจ */}
                                            <Col lg="6" md="6" xs="12">
                                                <div className="d-flex justify-content-between align-items-center mt-2">
                                                    <Label>
                                                        หนังสือมอบอำนาจพร้อมติดอากรแสตมป์ (กรณีมอบอำนาจ)
                                                    </Label>
                                                    {errors.fAuthorizePath ? (
                                                        <span className="text-left text-danger mx-1">{errors.fAuthorizePath}</span>
                                                    ) : null}
                                                    <div>
                                                        {values.fAuthorizePathView ? (
                                                            <FaSistrix
                                                                className="mx-3 style-icon"
                                                                onClick={onClickUrl(`${values.fAuthorizePathView}`)}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <Input
                                                    name="fAuthorizePath"
                                                    type="file"
                                                    onBlur={handleBlur}
                                                    className={
                                                        touched.fAuthorizePath && errors.fAuthorizePath
                                                            ? "input-error rounded-pill text-center input-color my-2"
                                                            : "rounded-pill text-center input-color my-2"
                                                    }
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        if (e.target && e.target.files[0]) {
                                                            setFieldValue(`fAuthorizePath`, e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                            </Col>

                                            {/* บัตร ปชช. กรรมการผู้มีอำนาจลงนาม */}
                                            <Col lg="6" md="6" xs="12">
                                                <div className="d-flex justify-content-between align-items-center pt-2">
                                                    <Label>
                                                        สำเนาบัตรประจำตัวประชาชนของกรรมการผู้มีอำนาจลงนาม (กรณีมอบอำนาจ)
                                                    </Label>
                                                    {errors.fIdCardPath ? (
                                                        <span className="text-left text-danger mx-1">{errors.fIdCardPath}</span>
                                                    ) : null}
                                                    <div>
                                                        {values.fIdCardPathView ? (
                                                            <FaSistrix
                                                                className="mx-3 style-icon"
                                                                onClick={onClickUrl(`${values.fIdCardPathView}`)}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <Input
                                                    name="fIdCardPath"
                                                    type="file"
                                                    onBlur={handleBlur}
                                                    className={
                                                        touched.fIdCardPath && errors.fIdCardPath
                                                            ? "input-error rounded-pill text-center input-color my-2"
                                                            : "rounded-pill text-center input-color my-2"
                                                    }
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        if (e.target && e.target.files[0]) {
                                                            setFieldValue(`fIdCardPath`, e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                            </Col>

                                            {/* บัตร ปชช. ผู้รับมอบอำนาจ */}
                                            <Col lg="6" md="6" xs="12">
                                                <div className="d-flex justify-content-between align-items-center pt-2">
                                                    <Label>
                                                        สำเนาบัตรประจำตัวประชาชนของกรรมการผู้รับมอบอำนาจ (กรณีมอบอำนาจ)
                                                    </Label>
                                                    {errors.fAuthoriseIdCardPath ? (
                                                        <span className="text-left text-danger mx-1">{errors.fAuthoriseIdCardPath}</span>
                                                    ) : null}
                                                    <div>
                                                        {values.fAuthoriseIdCardPathView ? (
                                                            <FaSistrix
                                                                className="mx-3 style-icon"
                                                                onClick={onClickUrl(`${values.fAuthoriseIdCardPathView}`)}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <Input
                                                    name="fAuthoriseIdCardPath"
                                                    type="file"
                                                    onBlur={handleBlur}
                                                    className={
                                                        touched.fAuthoriseIdCardPath && errors.fAuthoriseIdCardPath
                                                            ? "input-error rounded-pill text-center input-color my-2"
                                                            : "rounded-pill text-center input-color my-2"
                                                    }
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        if (e.target && e.target.files[0]) {
                                                            setFieldValue(`fAuthoriseIdCardPath`, e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                            </Col>

                                            {/* เครดิตบูโร */}
                                            <Col lg="6" md="6" xs="12">
                                                <div className="d-flex justify-content-between align-items-center pt-2">
                                                    <Label>
                                                        รายงานข้อมูลเครดิตบูโรของนิติบุคคลที่กู้ยืม (ไม่เกิน 30 วัน ในวันที่ยื่นคำขอกู้)
                                                        {!values.fBureauPathView ? <span className="require-input">*</span> : null}
                                                    </Label>
                                                    {touched.fBureauPath && errors.fBureauPath ? (
                                                        <span className="text-left text-danger px-1">{errors.fBureauPath}</span>
                                                    ) : null}
                                                    <div>
                                                        {values.fBureauPathView ? (
                                                            <FaSistrix
                                                                className="mx-3 style-icon"
                                                                onClick={onClickUrl(`${values.fBureauPathView}`)}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <Input
                                                    name="fBureauPath"
                                                    type="file"
                                                    onBlur={handleBlur}
                                                    className={
                                                        touched.fBureauPath && errors.fBureauPath
                                                            ? "input-error rounded-pill text-center input-color my-2"
                                                            : "rounded-pill text-center input-color my-2"
                                                    }
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        if (e.target && e.target.files[0]) {
                                                            setFieldValue(`fBureauPath`, e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                            </Col>

                                            {/* งบแสดงฐานะการเงิน 2 ปี */}
                                            <Col lg="6" md="6" xs="12">
                                                <div className="d-flex justify-content-between align-items-center pt-2">
                                                    <Label>
                                                        รายงานงบแสดงฐานะการเงิน ซึ่งผ่านการตรวจสอบจากผู้สอบบัญชีเรียบร้อยแล้ว ย้อนหลัง 2 ปี
                                                        {!values.fStatementPathView ? <span className="require-input">*</span> : null}
                                                    </Label>
                                                    {touched.fStatementPath && errors.fStatementPath ? (
                                                        <span className="text-left text-danger px-1">{errors.fStatementPath}</span>
                                                    ) : null}
                                                    <div>
                                                        {values.fStatementPathView ? (
                                                            <FaSistrix
                                                                className="mx-3 style-icon"
                                                                onClick={onClickUrl(`${values.fStatementPathView}`)}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <Input
                                                    name="fStatementPath"
                                                    type="file"
                                                    onBlur={handleBlur}
                                                    className={
                                                        touched.fStatementPath && errors.fStatementPath
                                                            ? "input-error rounded-pill text-center input-color my-2"
                                                            : "rounded-pill text-center input-color my-2"
                                                    }
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        if (e.target && e.target.files[0]) {
                                                            setFieldValue(`fStatementPath`, e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                            </Col>

                                            {/* แผนที่ตั้งสถานประกอบการ */}
                                            <Col lg="6" md="6" xs="12">
                                                <div className="d-flex justify-content-between align-items-center pt-2">
                                                    <Label>
                                                        แผนที่ตั้งสถานที่ประกอบกิจการ / ผู้ดำเนินการทดสอบฝีมือแรงงาน
                                                        {!values.fLocationPathView ? <span className="require-input">*</span> : null}
                                                    </Label>
                                                    {touched.fLocationPath && errors.fLocationPath ? (
                                                        <span className="text-left text-danger px-1">{errors.fLocationPath}</span>
                                                    ) : null}
                                                    <div>
                                                        {values.fLocationPathView ? (
                                                            <FaSistrix
                                                                className="mx-3 style-icon"
                                                                onClick={onClickUrl(`${values.fLocationPathView}`)}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <Input
                                                    name="fLocationPath"
                                                    type="file"
                                                    onBlur={handleBlur}
                                                    className={
                                                        touched.fLocationPath && errors.fLocationPath
                                                            ? "input-error rounded-pill text-center input-color my-2"
                                                            : "rounded-pill text-center input-color my-2"
                                                    }
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        if (e.target && e.target.files[0]) {
                                                            setFieldValue(`fLocationPath`, e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                            </Col>

                                            {/* รายการส่งเงินสมทบ สปส. */}
                                            <Col lg="6" md="6" xs="12">
                                                <div className="d-flex justify-content-between align-items-center pt-2">
                                                    <Label>
                                                        รายการแสดงการส่งเงินสมทบ(สปส. 1-10 ส่วนที่ 1 ณ เดือนสุดท้ายก่อนยื่นคำขอกู้ หรือ เดือนที่ยื่นคำขอกู้)
                                                        {!values.fSubsidyPathView ? <span className="require-input">*</span> : null}
                                                    </Label>
                                                    {touched.fSubsidyPath && errors.fSubsidyPath ? (
                                                        <span className="text-left text-danger px-1">{errors.fSubsidyPath}</span>
                                                    ) : null}
                                                    <div>
                                                        {values.fSubsidyPathView ? (
                                                            <FaSistrix
                                                                className="mx-3 style-icon"
                                                                onClick={onClickUrl(`${values.fSubsidyPathView}`)}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <Input
                                                    name="fSubsidyPath"
                                                    type="file"
                                                    onBlur={handleBlur}
                                                    className={
                                                        touched.fSubsidyPath && errors.fSubsidyPath
                                                            ? "input-error rounded-pill text-center input-color my-2"
                                                            : "rounded-pill text-center input-color my-2"
                                                    }
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        if (e.target && e.target.files[0]) {
                                                            setFieldValue(`fSubsidyPath`, e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                            </Col>

                                            {/* เอกสารอื่นๆ */}
                                            <Col lg="6" md="6" xs="12">
                                                <div className="d-flex justify-content-between align-items-center pt-2">
                                                    <Label>เอกสารอื่นๆ (ถ้ามี)</Label>
                                                    {touched.fOtherPath && errors.fOtherPath ? (
                                                        <span className="text-left text-danger px-1">{errors.fOtherPath}</span>
                                                    ) : null}
                                                    <div>
                                                        {values.fOtherPathView ? (
                                                            <FaSistrix
                                                                className="mx-3 style-icon"
                                                                onClick={onClickUrl(`${values.fOtherPathView}`)}
                                                            />
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <Input
                                                    name="fOtherPath"
                                                    type="file"
                                                    onBlur={handleBlur}
                                                    className={
                                                        touched.fOtherPath && errors.fOtherPath
                                                            ? "input-error rounded-pill text-center input-color my-2"
                                                            : "rounded-pill text-center input-color my-2"
                                                    }
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        if (e.target && e.target.files[0]) {
                                                            setFieldValue(`fOtherPath`, e.target.files[0]);
                                                        }
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                    {/* term */}

                                    <div className="w-100">
                                        <p className="text-left bg-warning py-1"><section className="ms-3">คำรับรอง *</section></p>
                                        <Col className="mx-3 text-dark">
                                            หากกรมพัฒนาฝีมือแรงงานอนุมัติให้กู้เงินได้ตามคำขอกู้ฉบับนี้
                                            ข้าพเจ้าขอรับรองว่า การที่กรมพัฒนาฝีมือแรงงาน
                                            ได้ส่งเอกสารหรือหนังสือใดๆ ไปยังที่อยู่ ที่ทำงาน
                                            หรือสถานที่ติดต่อตามข้อมูลที่ข้าพเจ้า
                                            ได้ให้ไว้แก่กรมพัฒนาฝีมือแรงงาน ในคำขอกู้นี้
                                            ไม่ว่าจะทำด้วยวิธีใดก็ตาม
                                            ข้าพเจ้ายินยอมให้ถือว่ากรมพัฒนาฝีมือแรงงานได้ส่งหรือแจ้งแก่ข้าพเจ้าโดยชอบแล้ว
                                            ในกรณีที่ข้าพเจ้าเปลี่ยนแปลงข้อมูลใดๆ
                                            ที่แจ้งไว้แก่กรมพัฒนาฝีมือแรงงาน
                                            ข้าพเจ้าจะแจ้งการเปลี่ยนแปลงนั้น
                                            เป็นหนังสือให้กรมพัฒนาฝีมือแรงงานทราบทันที หากไม่แจ้ง
                                            ข้าพเจ้าให้ถือว่าข้อมูลที่ได้แจ้งไว้ เป็นข้อมูลที่ถูกต้อง
                                        </Col>
                                    </div>
                                    <div className="d-flex justify-content-center mt-3 ">
                                        <Input
                                            className=""
                                            type="checkbox"
                                            id="term"
                                            name="term"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e);
                                            }}
                                            value={values.term}
                                            checked={values.term}
                                        />
                                        <Label for="term" className="mx-2">
                                            ยอมรับ
                                        </Label>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center m-5">
                                        <button type="button" className="btn-blue mx-2 px-4 w-25" onClick={() => navigate("/borrowing")}>
                                            ย้อนกลับ
                                        </button>
                                        <button type="submit" className="btn-blue mx-2 px-4 w-25">
                                            ถัดไป
                                        </button>
                                    </div>
                                </Form>
                            </div>
                        )}
                    </Container>
                );
            }}
        </Formik>
    );
}
